import { render, staticRenderFns } from "./GridMatchButtonsController.vue?vue&type=template&id=989a8308&scoped=true&"
import script from "./GridMatchButtonsController.vue?vue&type=script&lang=js&"
export * from "./GridMatchButtonsController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989a8308",
  null
  
)

export default component.exports